import { render, staticRenderFns } from "./UserBindForm.vue?vue&type=template&id=71425fd1&scoped=true&"
import script from "./UserBindForm.vue?vue&type=script&lang=js&"
export * from "./UserBindForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71425fd1",
  null
  
)

export default component.exports